









import { Component, Vue } from 'vue-property-decorator';
import ButtonsPanelComponent from '@/components/ToolsBar/ButtonsPanelComponent.vue';
import QuickFilterComponent from '@/components/ToolsBar/QuickFilterComponent.vue';

@Component({
  name: 'tools-bar-component',
  components: { ButtonsPanelComponent, QuickFilterComponent },
})
export default class ToolsBarComponent extends Vue {

}
